const models = state => state.models
const users = state => state.users
const user = state => state.user
const isLoading = state => state.loading

export default {
  models,
  users,
  user,
  isLoading
}



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js